import { Injectable, signal } from '@angular/core';

import { PageLevelMessage } from './page-level-message';

/**
 * Service dealing with app messages.
 *
 * @author Jesse Bloomster e020902
 */
@Injectable({
	providedIn: 'root'
})
export class PageLevelMessageService {
	messages = signal<PageLevelMessage[]>([]);

	/**
	 * Add a page level message.
	 *
	 * @param message the message to add
	 * @param clearAll if all prior messages should be cleared first
	 */
	addPageLevelMessage(message: PageLevelMessage, clearAll = true) {
		if (clearAll) {
			this.messages.set([message]);
		} else {
			this.messages.update(ms => [...ms, message]);
		}
	}

	/**
	 * Clear all the existing page level messages.
	 */
	clearPageLevelMessages() {
		this.messages.set([]);
	}
}
